import styled from '@emotion/styled';
import { nafColor } from '@nafcore/theme';
import { spacing } from '@naf/theme';
import { AppLink } from '../../AppLink/AppLink';

export const LinkItem = styled(AppLink)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${nafColor.signature.black};
  text-decoration: none;
  padding: ${spacing.space8} 0;

  span {
    color: inherit;
  }
`;

export const HighlightedLinkItem = styled(AppLink)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${nafColor.signature.black};
  text-decoration: none;
  padding: ${spacing.space4} 0;
`;
